module.exports = __webpack_public_path__ + "img/qr.299880da.svg";